import React from 'react';
import styled from 'styled-components';
import { TBannerModuleGroup } from '@com/core/common/types/catalog';
import ModuleHeader from '../moduleHeader/moduleHeader';
import BannerContent from '../bannerModule/bannerContent/bannerContent';

const BannerGroup = styled.div`
    display: flex;
    margin-left: -16px;
`;

const BannerWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    padding-left: 16px;
    margin: -16px 0 0 -16px;
`;

const BannerContainer = styled.div`
    padding: 16px 0 0 16px;
    flex: 1;
`;

type TProps = {
    moduleData: TBannerModuleGroup;
};

const BannerModuleGroup = ({ moduleData }: TProps): JSX.Element => {
    const { banners, moduleHeader, textColor } = moduleData;
    const supportBanners = banners.slice(1);

    return (
        <div>
            {moduleHeader && <ModuleHeader data={moduleHeader} textColor={textColor} />}
            <BannerGroup className="siteWidthContainer">
                <BannerWrapper>
                    <BannerContainer>
                        <BannerContent bannerData={banners[0]} />
                    </BannerContainer>
                </BannerWrapper>
                <BannerWrapper>
                    {supportBanners.map(banner => (
                        <BannerContainer key={banner.imageUrl} style={{ flex: '0 0 50%' }}>
                            <BannerContent bannerStyle="bgImage" bannerData={banner} />
                        </BannerContainer>
                    ))}
                </BannerWrapper>
            </BannerGroup>
        </div>
    );
};

export default BannerModuleGroup;
